import React, {Component}               from 'react';
import PropTypes                        from 'prop-types';
import FieldError                       from '../Fragments/FieldError';
import Field                            from '../Field';

import CountryList from '../Data/CountryList';
let FaSpinner = require('react-icons/lib/fa/spinner');
let Quote =  require('../Managers/Quote');
let HttpService = require('../Managers/HttpService');
let envConfig;

class AddressInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isHelpVisible: false,
            hasError: false,
            pafLookupPostcode: false,
            pafResults: false,
            activeValue: false,
            isManualEntryVisible: false,
            isForeignEntryVisible: false,
            didPostcodeLookupFail: false,
            showForeignToggle: true,
            showManualToggle: true,
            isSpinning: false,
            defaultValue: null,
            hideInput: false,
            postcode: null,
            showForeignAddressError: null,
        };
        this.inputComponents = [];
    }

    componentWillMount() {
        if (!window.uorn(this.props.defaultValue) && !window.uorn(this.props.defaultValue.postcode)) {
            this.setState({
                defaultValue : this.props.defaultValue,
                hideInput: true,
                isValid:true
            });
            this.props.isValid(true);
        }

        envConfig = HttpService.getConfigForHost();
    }

    componentDidMount() {
        this.props.wrapperField.setLayoutClass("address-field");
        this.props.wrapperField.toggleHelpIcon(false);
    }

    componentWillUpdate() {
        this.inputComponents = [];
    }

    componentDidUpdate() {
        if (this.state.isForeignEntryVisible === true) {
            Quote.set('postcode', '1001', this.props.source);
        }
    }

    componentWillUnmount() {
        this.childComponents = [];
    }

    getChildInputComponents() {
        return this.inputComponents;
    }

    resetState() {
        this.setState(this.constructor());
    }

    setPafLookupPostcode(event) {
        let pc = event.target.value.replace(/\s+/g, '').toUpperCase();

        if (pc.length > 4) {
            this.setState({
                pafLookupPostcode: pc
            });
        }
    }

    pafLookup() {
        let postcode = document.getElementById(this.props.fieldName + 'Postcode').value.replace(/\s+/g, '').toUpperCase();
        this.setState({ isSpinning: true });
        this.getQuoteRequest = $.ajax({
            type: envConfig.addressLookup.method,
            url: envConfig.addressLookup.url+"/"+postcode,
            dataType: 'json',
            success: (res) => {
                if (res.results.length >= 1) {
                    this.setState({
                        pafResults: res.results,
                        didPostcodeLookupFail: false,
                        isSpinning: false,
                        isManualEntryVisible: false,
                        isForeignEntryVisible: false,
                    });
                } else {
                    this.setState({
                        pafResults: [],
                        didPostcodeLookupFail: true,
                        isManualEntryVisible: (this.props.addressOptions.canHaveManualEntry || this.props.addressOptions.hasManualEntryOption) === true ? true : false,
                        hasError: false,
                        isValid: true,
                        isSpinning: false,
                        showManualToggle: false,
                    });
                }

            },
            error: () => {
                this.setState({
                    pafResults: [],
                    didPostcodeLookupFail: true,
                    isManualEntryVisible: (this.props.addressOptions.canHaveManualEntry || this.props.addressOptions.hasManualEntryOption) === true ? true : false,
                    hasError: false,
                    isValid: true,
                    isSpinning: false,
                    showManualToggle: false,
                });
            }
        });

        // Remove/reset an address if it had been set previously
        Quote.deleteByPath('Case.address');
        Quote.deleteByPath(this.props.source);

        // Reset any previously selected address
        let selector = document.getElementById(this.props.fieldName + 'Selection');
        if (selector) {
            selector.value = '0';
        }
    }

    /**
     * Set the non-false values for the address parts against the source prop
     * for this component.
     *
     * @param event
     */
    setAddress(event) {
        let addressObject = JSON.parse(event.target.value);
        addressObject.sub_building_name === false ? null : Quote.set('flat', String(addressObject.sub_building_name), this.props.source);
        addressObject.building_name === false ? null : Quote.set('houseName', String(addressObject.building_name), this.props.source);
        addressObject.building_number === false ? null : Quote.set('houseNumber', String(addressObject.building_number), this.props.source);
        addressObject.street === false ? null : Quote.set('street', String(addressObject.street), this.props.source);
        addressObject.district === false ? null : Quote.set('locality', String(addressObject.district), this.props.source);
        addressObject.town === false ? null : Quote.set('town', String(addressObject.town), this.props.source);
        addressObject.county === false ? null : Quote.set('county', String(addressObject.county), this.props.source);
        addressObject.country === false ? null : Quote.set('country', String(addressObject.country), this.props.source);
        addressObject.postcode === false ? null : Quote.set('postcode', String(addressObject.postcode), this.props.source);

        if (addressObject.sub_building_name === false && addressObject.building_name === false && addressObject.building_number === false) {
            Quote.set('houseName', String(addressObject.organisation), this.props.source);
        }

        // If they've picked an address, it CAN'T be foreign
        Quote.set('foreign', false, this.props.source);
        this.managePossibleForeignAddress(false);

        // Force validation to resolve as OK
        this.setState({
            isValid: true,
            hasError: false,
        });
        this.props.isValid(true);
    }

    handleValidation() {
        if (!window.uorn(this.props.defaultValue) || this.state.isManualEntryVisible === true || this.state.isForeignEntryVisible === true) {
            // if we have a default value, we must be valid
            this.props.isValid(true);
            if (this.state.isForeignEntryVisible === true) {
                // If it's a foreign address, we do a different set of checks
                // against fields.
                if (
                    window.uornorb(document.getElementById(this.props.fieldName + 'Flat').value)
                    && window.uornorb(document.getElementById(this.props.fieldName + 'HouseName').value)
                    && window.uornorb(document.getElementById(this.props.fieldName + 'HouseNumber').value)
                ) {
                    this.props.isValid(false);
                    this.setState({
                        showForeignAddressError: true,
                        isValid: false,
                        hasError: true,
                    });
                } else {
                    this.setState({showForeignAddressError: false});
                    // If we have at least one of the above AND a town/city, then we
                    // have a valid foreign address.
                    if (!window.uornorb(document.getElementById(this.props.fieldName + 'Town'))) {
                        this.setState({
                            isValid: true,
                            hasError: false,
                        });
                    }
                }
            } else {
                return true;
            }
        } else {
            // the postcode never got set
            if (window.uorn(this.state.postcode)) {
                this.setState({
                    isValid:false,
                    hasError:true,
                    errors:[
                        "Please submit a postcode and select an address"
                    ]
                });
                this.props.isValid(false);
            }
        }
    }

    /**
     * used for validation - is effectively moot
     * as the FPV handleValidation does not require
     * a current value, but no function will cause an error
     * @return {true}
     */
    getCurrentValue() {
        return true;
    }

    setForeignAddressManualEntry(e) {
        e.preventDefault();
        this.setState({
            isValid: true,
            isForeignEntryVisible: true,
            isManualEntryVisible: false,
        });
        this.props.isValid(true);
        this.props.isTickVisible(false);
        if (this.props.callbackFunction) {
            this.props.callbackFunction(true);
        }
        this.props.wrapperField.toggleHelpIcon(true);

        // make sure the address is foreign
        Quote.set('foreign', true, this.props.source);
        this.managePossibleForeignAddress(true);
    }

    setForeignCountry(v) {
        Quote.set('addresscountry', v, this.props.source);
    }

    setForeignPostcode(v) {
        Quote.set('addresspostcode', v, this.props.source);
    }

    managePossibleForeignAddress(isAddressForeign) {
        if (this.props.source.includes('addressHistories')) {
            const addressHistoryPath = this.props.source.split('.')
            .filter(chunk => chunk != 'address')
            .join('.');

            Quote.setByPath(addressHistoryPath + '.isForeign', isAddressForeign);
        }
    }

    getCountryNameForCode(code) {
        let name = null;

        CountryList.map(countryObject => {
            if (countryObject.option_value == code) {
                name = countryObject.option_text;
            }
        });

        return name;
    }

    retryPostcodeLookup(e) {
        e.preventDefault();
        this.setState({
            didPostcodeLookupFail: false,
            pafLookupPostcode: null,
            isManualEntryVisible: false,
            isForeignEntryVisible: false,
            showManualToggle: true,
        });
        let fieldId = this.props.fieldName + 'Postcode';
        document.getElementById(fieldId).value = '';
        document.getElementById(fieldId).focus();
    }

    /**
     * We check against three different fields for saving foreign addresses - we
     * need AT LEAST one of them to be filled in in order for the address to be
     * considered as valid in IRIS.
     */
    checkForeignAddressConstraints() {
        if (this.state.isForeignEntryVisible === true) {
            if (
                window.uornorb(document.getElementById(this.props.fieldName + 'Flat').value)
                && window.uornorb(document.getElementById(this.props.fieldName + 'HouseName').value)
                && window.uornorb(document.getElementById(this.props.fieldName + 'HouseNumber').value)
            ) {
                this.setState({ showForeignAddressError: true });
            } else {
                this.setState({ showForeignAddressError: false });
            }
        }
    }

    render() {
        let dv = "0";
        let pafoptions = [];

        if (this.state.pafResults.length > 0) {
            pafoptions.push(<option key={0} value="0">Please select...</option>);
            this.state.pafResults.forEach(function(i, index){
                pafoptions.push(<option key={index + 1} value={JSON.stringify(i)}>{i.formatted}</option>);
            }, this);
        } else if (this.state.activeValue) {
            pafoptions.push(<option key={0}>{this.state.activeValue}</option>);
        }
        return (
            <div className={this.props.isInAModal === true ? 'question-input modal-field-input' : 'question-input'}>
                {!window.uorn(this.state.defaultValue) && this.state.hideInput ?
                    <div>
                        {this.state.defaultValue.foreign == true ?
                            <div>
                                <p><strong>{this.state.defaultValue.flat} {this.state.defaultValue.houseName}</strong></p>
                                <p><strong>{this.state.defaultValue.houseNumber} {this.state.defaultValue.street}</strong></p>
                                <p><strong>{this.state.defaultValue.town}</strong></p>
                                {this.state.defaultValue.county ? <p><strong>{this.state.defaultValue.county}</strong></p> : null }
                                <p><strong>{this.getCountryNameForCode(this.state.defaultValue.country)}</strong></p>
                            </div>
                        :
                            <div>
                                <p><strong>{this.state.defaultValue.flat} {this.state.defaultValue.houseName}</strong></p>
                                <p><strong>{this.state.defaultValue.houseNumber} {this.state.defaultValue.street}</strong></p>
                                <p><strong>{this.state.defaultValue.town}</strong></p>
                                {this.state.defaultValue.county ? <p><strong>{this.state.defaultValue.county}</strong></p> : null }
                                {this.state.defaultValue.postcode !== '1001' ? <p><strong>{this.state.defaultValue.postcode}</strong></p> : null}
                            </div>
                        }

                        <div>
                            <a href="" onClick={(e) => {
                                e.preventDefault();
                                this.setState({
                                    hideInput: false,
                                    isManualEntryVisible:false,
                                    isForeignEntryVisible:false,
                                    isValid: false,
                                    hasError: true,
                                }, () => {
                                    this.props.isValid(false);
                                });
                                Quote.deleteByPath(this.props.source); // delete the previously entered address
                            }}>Change this address</a>
                        </div>
                    </div>
                : null}

                {!this.state.hideInput ?
                    <div>
                        <div className="question-top">
                            <label htmlFor={this.props.fieldName}>{this.props.question}</label>
                        </div>
                        <div className="input-group paf">
                            <input id={this.props.fieldName + 'Postcode'} style={{textTransform: 'uppercase'}} type="text" name="pafsource" onBlur={this.setPafLookupPostcode.bind(this)} onKeyUp={() => {
                                    this.setState({
                                        pafResults: [],
                                        didPostcodeLookupFail: false,
                                        hasError: true
                                    });
                                    this.props.isValid(false);
                                }} />
                            <button className="btn btn-default" onClick={this.pafLookup.bind(this)}>
                                Find address {this.state.isSpinning ? <FaSpinner className="spin" /> : null}
                            </button>
                        </div>

                        {/* Postcode lookup was successful and there are one or more results */}
                        {(this.state.pafResults.length > 0 || this.state.activeValue) && this.state.isManualEntryVisible === false ?
                            <div className="address-selection">
                                {this.state.pafResults ?
                                    <label>Please select your address from the list</label>
                                : null}
                                <select id={this.props.fieldName + 'Selection'} defaultValue={dv} onChange={this.setAddress.bind(this)}>{pafoptions}</select>
                            </div>
                        : null}

                        {/* Manual entry is visible because the postcode lookup failed */}
                        {this.state.didPostcodeLookupFail === true && this.state.pafResults.length < 1 && this.props.addressOptions.canHaveManualEntry === true ?
                            <div className="supplemental-bubble">
                                <div className="arrow" />
                                <p>Unfortunately, we couldn't find your property address{this.state.pafLookupPostcode ? <span> from "<em>{this.state.pafLookupPostcode}</em>"</span> : null} - <a href="" className="underline" onClick={this.retryPostcodeLookup.bind(this)}>click to try again</a>. Alternatively, enter it manually below:</p>
                            </div>
                        : null}

                        {/* Postcode lookup failed, and manual entry is not allowed for this address type */}
                        {this.state.didPostcodeLookupFail === true && this.state.pafResults.length < 1 && this.props.addressOptions.canHaveManualEntry === false ?
                            <div className="supplemental-bubble">
                                <div className="arrow" />
                                <p>Unfortunately, we couldn't find your property address{this.state.pafLookupPostcode ? <span> from "<em>{this.state.pafLookupPostcode}</em>"</span> : null}. Please check and try again.</p>
                            </div>
                        : null}

                        <p>
                            {/* link to get to manual because its foreign */}
                            {this.props.addressOptions.canBeForeign === true && this.state.showForeignToggle === true ?
                                <a onClick={this.setForeignAddressManualEntry.bind(this)} className="underline">Click here if the address is not in the UK</a>
                            : null}

                            {this.props.addressOptions.canHaveManualEntry === true && this.props.addressOptions.canBeForeign === true && this.state.didPostcodeLookupFail === false ?
                                <span> or </span>
                            : null}

                            {/* link to get to manual because they want manual */}
                            {this.props.addressOptions.canHaveManualEntry === true && this.state.showManualToggle === true ?
                                <a onClick={() => {
                                    this.props.wrapperField.toggleHelpIcon(false);
                                    this.setState({
                                        isValid: true,
                                        isManualEntryVisible: true,
                                        isForeignEntryVisible: false,
                                    });
                                    this.props.isValid(true);
                                    this.props.isTickVisible(false);
                                    if (this.props.callbackFunction) {
                                        this.props.callbackFunction(false);
                                    }
                                    Quote.set('foreign', false, this.props.source);
                                    this.managePossibleForeignAddress(false);
                                }} className="underline">Enter address manually</a>
                            : null}
                        </p>

                        {this.state.isManualEntryVisible === true || this.state.isForeignEntryVisible === true ?
                            <div>
                                <Field
                                    type="text"
                                    question="Flat"
                                    fieldName={this.props.fieldName + 'Flat'}
                                    storageKey="flat"
                                    maxLength={32}
                                    hasBorder={false}
                                    questionExtra={false}
                                    layoutClass="child-question-row"
                                    source={this.props.source}
                                    dataValidation="required_field.non_mandatory"
                                    ref={(instance) => {this.inputComponents.push(instance);}}
                                    callbackFunction={this.checkForeignAddressConstraints.bind(this)}
                                />

                                <Field
                                    type="text"
                                    question="House name"
                                    fieldName={this.props.fieldName + 'HouseName'}
                                    storageKey="houseName"
                                    maxLength={32}
                                    hasBorder={false}
                                    questionExtra={false}
                                    layoutClass="child-question-row"
                                    source={this.props.source}
                                    dataValidation="required_field.non_mandatory"
                                    ref={(instance) => {this.inputComponents.push(instance);}}
                                    callbackFunction={this.checkForeignAddressConstraints.bind(this)}
                                />

                                <Field
                                    type="number"
                                    question="House number"
                                    fieldName={this.props.fieldName + 'HouseNumber'}
                                    storageKey="houseNumber"
                                    maxLength={32}
                                    hasBorder={false}
                                    questionExtra={false}
                                    dataValidation={this.state.isForeignEntryVisible ? "required_field.non_mandatory" : "required_field"}
                                    layoutClass="child-question-row"
                                    source={this.props.source}
                                    ref={(instance) => {this.inputComponents.push(instance);}}
                                    callbackFunction={this.checkForeignAddressConstraints.bind(this)}
                                />

                                {this.state.showForeignAddressError === true ?
                                    <FieldError
                                        type="warning"
                                        errors={['We need to know one of Flat, House name, or House number for foreign addresses before you can proceed.']}
                                    />
                                : null}

                                <Field
                                    type="text"
                                    question="Street"
                                    fieldName={this.props.fieldName + 'Street'}
                                    storageKey="street"
                                    maxLength={32}
                                    hasBorder={false}
                                    dataValidation="required_field.non_mandatory"
                                    layoutClass="child-question-row"
                                    source={this.props.source}
                                    ref={(instance) => {this.inputComponents.push(instance);}}
                                />

                                <Field
                                    type="text"
                                    question="Town"
                                    fieldName={this.props.fieldName + 'Town'}
                                    storageKey="town"
                                    maxLength={32}
                                    hasBorder={false}
                                    dataValidation="required_field"
                                    layoutClass="child-question-row"
                                    source={this.props.source}
                                    ref={(instance) => {this.inputComponents.push(instance);}}
                                />

                                {this.state.isManualEntryVisible === true && this.state.isForeignEntryVisible === false ?
                                    <Field
                                        type="postcode"
                                        question="Postcode"
                                        fieldName={this.props.fieldName + 'Postcode'}
                                        storageKey="postcode"
                                        maxLength={32}
                                        hasBorder={false}
                                        dataValidation="postcode"
                                        layoutClass="child-question-row"
                                        source={this.props.source}
                                        isUppercase={true}
                                        ref={(instance) => {this.inputComponents.push(instance);}}
                                    />
                                : null}

                                <Field
                                    type="text"
                                    question="County"
                                    fieldName={this.props.fieldName + 'County'}
                                    storageKey="county"
                                    maxLength={32}
                                    hasBorder={false}
                                    layoutClass="child-question-row"
                                    source={this.props.source}
                                    dataValidation="required_field.non_mandatory"
                                    ref={(instance) => {this.inputComponents.push(instance);}}
                                />

                                {this.state.isForeignEntryVisible === true && this.state.isManualEntryVisible === false ?
                                    <Field
                                        type="select"
                                        isCountrySelection={true}
                                        question="Country"
                                        fieldName={this.props.fieldName + 'Country'}
                                        storageKey="country"
                                        maxLength={32}
                                        hasBorder={false}
                                        layoutClass="child-question-row"
                                        dataValidation="required_field"
                                        source={this.props.source}
                                        ref={(instance) => {this.inputComponents.push(instance);}}
                                    />
                                : null}
                            </div>
                        : null}
                    </div>
                : null }

                {this.state.hasError === true ?
                    <FieldError errors={this.state.errors} />
                :null}
            </div>
        );
    }
}

AddressInput.propTypes = {
    fieldName:          PropTypes.string.isRequired,
    storageKey:         PropTypes.string,
    defaultValue:       PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
    ]),
    helpText:           PropTypes.string,
    question:           PropTypes.string.isRequired,
    isTickVisible:      PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.func,
    ]),
    source:             PropTypes.string,
    addressOptions:     PropTypes.shape({
        pafLookup:              PropTypes.bool.isRequired,
        canHaveManualEntry:     PropTypes.bool,
        hasManualEntryOption:   PropTypes.bool,
        canBeForeign:           PropTypes.bool,
    }).isRequired,
    isValid:            PropTypes.func,
    wrapperField:       PropTypes.object,
    callbackFunction:   PropTypes.func,
    isInAModal:         PropTypes.bool,
};

AddressInput.defaultProps = {
    addressOptions: {
        canHaveManualEntry: false,
        hasManualEntryOption: false,
        canBeForeign: false,
        isInAModal: false,
    }
};

export default AddressInput;



// WEBPACK FOOTER //
// ./src/components/Fields/AddressInput.js